var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-col',{attrs:{"type":"flex","vs-justify":"center","vs-align":"center"}},[_c('vs-card',{staticClass:"cardx"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("\r\n            Estado General BoxStreamer\r\n          ")])]),_c('div',[_c('States')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }